import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ECHILD } from 'constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-center-allocation',
  templateUrl: './center-allocation.component.html',
  styleUrls: ['./center-allocation.component.scss']
})
export class CenterAllocationComponent implements OnInit {
  centerAlloForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  Table = false;
  DataList1: any;
  filteredDataList1: any;
  filteredCenterData: any;
  CenterData: any;
  listdesc: any;
  clgname: any;
  show = false;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, public router: Router,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getInputSpFlag(this.SessionNo);
    }
    this.Table = false
    window.scroll(0,0)
    this.centerAlloForm = this.fb.group({
      listNo: new FormControl(),
      listNo2: new FormControl(),
      listNo3: new FormControl('New'),
      Valid: new FormControl(),
      Chng: new FormControl(),
      CaTnCode: new FormControl(),
      CaCgCode: new FormControl(),
      CnName: new FormControl('',Validators.required),
      TnName: new FormControl(),
      CaCand: new FormControl(),
      CaCent: new FormControl(),
      CgName: new FormControl(),
      CaAllo: new FormControl(),
      EcId: new FormControl(),
      CaType: new FormControl('T')
     } );
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.getInputSpFlag(this.SessionNo);
      }
      else{
        this.spinner.hide()
      }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }

  getInputSpFlag(sessid){
    this.spinner.show()
    const payload = {};
    this.umsService.getInputSearch(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        if(res.data[0].InCode == 20){ //depending on incode decide which api to call for list dropdown
          this.getExmFrmList(res.data[0].InCode,sessid);
        }
        else{
          this.getRegnFrmList(res.data[0].InCode,sessid);
        }
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getExmFrmList(id,sessid){
    this.spinner.show()
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = sessid;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      } else {
        this.spinner.hide()
        this.DataList = [];
        this.filteredDataList = this.DataList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getRegnFrmList(id,sessid){
    this.spinner.show()
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = sessid;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getRegnFrmList(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      }
      else{
        this.spinner.hide()
      } 
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getSearchCentFor(id){
    this.spinner.show()
    const payload = {};
    payload['TnCode'] = '';
    payload['EcId'] = id
    this.umsService.getCentForAll(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.CenterData = res.data;
        this.filteredCenterData = this.CenterData.slice();
      } else {
        this.spinner.hide()
        this.CenterData = [];
        this.filteredCenterData = this.CenterData.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getCenterData(Cent){ 
    this.centerAlloForm.controls['CaCent'].setValue(Cent.CgCode);
  }

  getGridData(ECid){
    this.show = false;
    this.getSearchCent(ECid);
    this.getSearchCentFor(ECid);
    this.listdesc = ECid
  }

  edit(k,id){
    if (k === 'true') {
      this.show = true;
      this.prepopulation(id);
    }
  }

  prepopulation(data){
        // /this.centerAlloForm.controls['listNo'].setValue(this.listdesc);
    this.centerAlloForm = this.fb.group({
      listNo: new FormControl(this.listdesc),
      listNo2: new FormControl(''),
      listNo3: new FormControl(''),
      Valid: new FormControl(data.Valid),
      Chng: new FormControl(data.Chng),
      CaTnCode: new FormControl(data.CaTnCode),
      TnName: new FormControl(data.TnName),
      CaCand: new FormControl(data.CaCand),
      CaCent: new FormControl(data.CaCent),
      CgName: new FormControl(data.CgName),
      CaAllo: new FormControl(data.CaCand),
      EcId: new FormControl(data.EcId),
      CaType: new FormControl(data.CaType),
      CaCgCode: new FormControl(data.CaCgCode),
      CnName: new FormControl(data.CnName,Validators.required)
     } );
  }

  getSearchCent(id){
    this.spinner.show()
    const payload = {};
    payload['EcId'] = id,
    payload['Valid'] = '',
    payload['Chng'] = '',
    this.umsService.getCentAll(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Table = true;
        this.DataList1 = res.data;
        this.filteredDataList1 = this.DataList1.slice();
      } else {
        this.spinner.hide()
        this.Table = false;
        this.DataList1 = [];
        this.filteredDataList1 = this.DataList1.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }
  
  update(){
    if (this.centerAlloForm.invalid) {
      this.centerAlloForm.get('CnName').markAsTouched();
      // this.centerAlloForm.get('EmCode').markAsTouched();
      // this.centerAlloForm.get('EmName').markAsTouched();
      // this.centerAlloForm.get('EmShName').markAsTouched();
      // this.centerAlloForm.get('EmSubTot').markAsTouched();
      
      return;
    } else {
      this.updateCentAll();
    }
  }

  updateCentAll() {
    this.spinner.show()
    let payload = {};
    payload['EcId'] = this.centerAlloForm.value['EcId'];
    payload['CaTnCode'] = '';
    payload['CaCgCode'] = this.centerAlloForm.value['CaCgCode'];
    payload['CaCent'] = this.centerAlloForm.value['CaCent'];
    payload['CaAllo'] = this.centerAlloForm.value['CaAllo'];
    payload['CaType'] = this.centerAlloForm.value['CaType'];
    this.umsService.updateCentAll(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.getGridData(payload['EcId']);
        }); 
      } else {
        this.spinner.hide()
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.getGridData(payload['EcId']);
        }); 
      }
    },
    (ERROR: HttpErrorResponse) => {
     this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  print(){
    let submitpayload = this.centerAlloForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Centre-Allocation';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 119,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.umsService.secretdata['SnNo'],
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
